import React from 'react';
import './Sidebar.css'
import {
    BrowserRouter as Router,
    Route,
    Link,
} from 'react-router-dom'
// import { Col, Button, Container, Row } from 'react-bootstrap';
import MyListing from '../../containers/MyListing/MyListing';
import Kycform from '../../containers/Kycform/Kycform';

const routes = [
    {
        path: '/myListings',
        exact: true,
        sidebar: () => <div><MyListing/></div>,
        main: () => <h2></h2>
    },
    {
        path: '/KYC',
        sidebar: () => <div><Kycform/></div>,
        main: () => <h2></h2>
    }
]

export class Sidebar extends React.Component {
    render() {
        return (
            <Router>
                <div>
                    <div className="wrapper-side-container">
                            <div className="row">
                                <div className="col-xs-4 col-sm-4 col-md-4">
                                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                                        <li><Link to="/myListings" className="side-link "><div className="link-style">My Listed Events</div></Link></li>
                                        <li><Link to="/KYC" className="side-link"><div className="link-style">KYC </div></Link></li>
                                    </ul>
                                </div>
                                <div className="col-xs-12 col-sm-8 col-md-8">
                                    {routes.map((route) => (
                                        <Route
                                            key={route.path}
                                            path={route.path}
                                            exact={route.exact}
                                            component={route.sidebar}
                                        />
                                    ))}
                                </div>
                            </div>
                       
                    </div>
                </div>
            </Router>
        )
    }
}

export default Sidebar